import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

const eventsSwiper = () => {
  const swiperConfig = {
    slidesPerView: 1,
    grabCursor: true,
    spaceBetween: 16,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 3,
      },
    },
  };

  const sliders = [
    {
      selector: '.bloc-events-swiper--all',
    },
    {
      selector: '.bloc-events-swiper--montmagny',
    },
    {
      selector: '.bloc-events-swiper--temiscouata',
    },
    {
      selector: '.bloc-events-swiper--la_pocatiere',
    },
  ];

  sliders.map((slider) => {
    return new Swiper(slider.selector, {
      ...swiperConfig,
    });
  });

  const tabs = document.querySelectorAll(
    '.bloc-events__tabs .bloc-events__tab'
  );
  const carrousels = document.querySelectorAll('.bloc-events__tabs-content');

  // Function to show the selected tab content
  function showTabCarrousel(tabIndex) {
    // Reset all tabs, carousels
    tabs.forEach((tab) => tab.classList.remove('bloc-events__tab--selected'));
    carrousels.forEach((carrousel) => (carrousel.style.display = 'none'));

    // Activate the selected tab
    if (tabs[tabIndex]) {
      tabs[tabIndex].classList.add('bloc-events__tab--selected');
    }

    // Show the corresponding carrousel
    if (carrousels[tabIndex]) {
      carrousels[tabIndex].style.display = 'flex';
    }
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => showTabCarrousel(index));
  });

  // Show the 'all' tab content by default
  showTabCarrousel(0);
};

/////////////// ON READY /////////////////
domReady(() => {
  eventsSwiper();
});
